<div role="application">
  <ul class="droppables {{droppables_class}}" role="list">
    {{#each droppables}}
      <li class="droppable {{class}}" id="{{id}}">
        {{#with header}}<div class="header{{#if class}} {{class}}{{/if}}">{{t text}}</div>{{/with}}
        {{#with description}}<div class="description{{#if class}} {{class}}{{/if}}">{{t text}}</div>{{/with}}
        {{#if blocks}}<div data-region="{{../cid}}-droppables-{{@index}}-blocks"></div>{{/if}}
        <ul class="dropped-draggables"></ul>
      </li>
      {{#if droppables_description}}<li>{{t droppables_description}}</li>{{/if}}
    {{/each}}
  </ul>

  <ul class="draggable-list {{draggables_class}}" role="list">
    {{#each draggables}}
      <li class="draggable {{id}} {{class}}" id="{{id}}" tabindex="0" role="listitem">
        {{#with header}}<div class="header{{#if class}} {{class}}{{/if}}">{{t text}}</div>{{/with}}
        {{#with description}}<div class="description{{#if class}} {{class}}{{/if}}">{{t text}}</div>{{/with}}
        {{#if blocks}}<div data-region="{{../cid}}-draggables-{{@index}}-blocks"></div>{{/if}}
      </li>
      {{#if draggables_description}}<li>{{t draggables_description}}</li>{{/if}}
    {{/each}}
  </ul>
</div>
<span class="alert drop-alert hide" role="alert"></span>
<div class="srCorrectIncorrectAnswer screen-reader-content" role="alert" aria-live="assertive"></div>
<div class="srInstructions" role="alert" aria-atomic="true"></div>
<div class="srText screen-reader-content" role="alert" aria-atomic="true"></div>
